<template>

  <div class="etx-container Container" :class="paragraphClassList">
    <div class="etx-center Center">

      <div class="etx-flex Flex mob-l:c-2 tab-l:c-3 gv-300 av-stretch">

        <div v-for="teaser in teasers" class="etx-flex__item Flex__item">

          <div class="etx-card Card has-shadow has-hover" :class="entranceClassList">

            <a class="etx-card__link Card__link" :href="teaser?.url?.path" :title="teaser?.heading"></a>

            <div class="etx-card__item Card__item ph-0 pv-0">

              <div class="etx-media Media">
                <MediaImage :media="teaser?.image" imageStyle="image_3_2" />
              </div>

            </div>

            <div class="etx-card__item Card__item pt-200 pb-150 grow-1">

              <div class="etx-text Text">
                <p class="font-size-smaller font-color-medium">{{ $texts('label_apprenticeship', 'Lehrberuf') }}</p>
                <p class="font-size-larger">
                  <span class="font-weight-bold">{{ teaser?.heading }}</span><br>
                  <span class="font-color-medium">{{ teaser?.headingSubline }}</span>
                </p>
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  </div>

</template>

<script lang="ts" setup>

const { $texts } = useNuxtApp()

const { options, isEditing } = defineBlokkli({
  bundle: 'apprenticeships_listing',
  globalOptions: ['spacingTop', 'spacingBottom'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  return classList
})

const entranceClassList = computed(() => {

  const classList = []

  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }

  return classList
})

const { data: teasers } = await useAsyncData('allApprenticeships', async () => {
  return await useGraphqlQuery('allApprenticeships').then((v) => v?.data?.entityQuery?.items as Array<{
    url: {
      path: string
    }
    heading: string
    headingSubline?: string
    image: {
      url: {
        path: string
      }
      alt: {
        alt: string
      }
      title: string
    }
  }>)
})

</script>